import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs/Sortable'

export default class extends Controller {
  get handle() {
    return '.move'
  }

  connect() {
    new Sortable(
      this.element,
      {
        handle: this.handle,

        onUpdate: (event) => {
          event.srcElement.querySelectorAll('input.position').forEach((input, index) => { input.value = index })
        }
      }
    )
  }
}
